<template>
  <div class="exam">
    <section class="container">
      <div class="is-centered">
        <h1 class="has-text-success huge-title">
          Your exam results
        </h1>
        <div class="subtitle is-4">
          <p>
            Score: <strong>{{results.exam_attempt_data.correct_answers}}</strong> out of <strong>{{results.exam_attempt_data.correct_answers + results.exam_attempt_data.incorrect_answers}}</strong>
          </p>
          <p>
            Overall Percentage: <strong>{{results.exam_attempt_data.result_percents}}%</strong>
          </p>
          <p>You can review your answers below</p>
        </div>

      </div>
      <div class="questionnaire mt-1">
        <ul class="question-numbers">
          <li
            v-for="question in results.questions"
            :key="question.index"
            :class="{
              active: question.selected,
              answered: question.answered,
              incorrect: question.student_answer !== question.correct
            }"
            class="number-border"
            @click="select(question)"
          >
            <div
              class="number"
              :class="{
                answered: question.answered,
                incorrect: question.student_answer !== question.correct
              }"
              v-html="question.index"
            />
          </li>
        </ul>

        <div class="question box mt-2 mb-1 has-greyish-background">
          <div v-html="current.question" />
        </div>

        <ul class="answers mt-2 ml-2 mr-2">
          <li
            :class="{
              correct: current.correct === 'A',
              'chosen-incorrect': current.correct !== current.student_answer && current.student_answer === 'A'
            }"
            class="answer"
          >
            <div class="is-flex">
              <div class="is-flex is-align-items-center check-mark-column">
                <span v-if="current.student_answer === 'A'" class="check-mark">
                  ✓
                </span>
              </div>
              <div style="flex: 1;">
                <span v-html="current.A" />
              </div>
            </div>
          </li>
          <li
            :class="{
              correct: current.correct === 'B',
              'chosen-incorrect': current.correct !== current.student_answer && current.student_answer === 'B'
            }"
            class="answer"
          >
            <div class="is-flex">
              <div class="is-flex is-align-items-center check-mark-column">
                <span v-if="current.student_answer === 'B'" class="check-mark">
                  ✓
                </span>
              </div>
              <div style="flex: 1;">
                <span v-html="current.B" />
              </div>
            </div>
          </li>
          <li
            :class="{
              correct: current.correct === 'C',
              'chosen-incorrect': current.correct !== current.student_answer && current.student_answer === 'C'
            }"
            class="answer"
          >
            <div class="is-flex">
              <div class="is-flex is-align-items-center check-mark-column">
                <span v-if="current.student_answer === 'C'" class="check-mark">
                  ✓
                </span>
              </div>
              <div style="flex: 1;">
                <span v-html="current.C" />
              </div>
            </div>
          </li>
        </ul>

        <div class="columns is-multiline mt-5">
          <div class="column is-6">
            <button
              v-if="current.index > 1"
              class="button is-primary is-medium is-full-width-touch"
              @click="selectPrevious"
              v-html="$t('pagination.previous')"
            />
          </div>
          <div class="column is-6 is-right">
            <button
              v-if="current.index < results.questions.length"
              class="button is-primary is-medium is-full-width-touch"
              @click="selectNext"
              v-html="$t('pagination.next')"
            />
            <a
              v-else
              :href="results.next_url"
              class="button is-primary is-medium is-full-width-touch"
              v-html="$t('exam.proceed')"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { find } from 'lodash';

export default {
  name: 'ExamResults',

  props: {
    exam_results: { type: Object, required: true }
  },

  data() {
    const q = _.first(this.exam_results.data.questions);
    q.selected = true;
    return {
      results: this.exam_results.data
    };
  },

  computed: {
    current() {
      return find(this.results.questions, q => q.selected);
    }
  },

  methods: {
    select(question) {
      this.results.questions.forEach(q => {
        q.selected = false;

        if (q.id === question.id) {
          q.selected = true;
        }
      });
    },

    selectNext() {
      this.select(
        find(this.results.questions, q => this.current.index + 1 === q.index)
      );
    },

    selectPrevious() {
      this.select(
        find(this.results.questions, q => this.current.index - 1 === q.index)
      );
    }
  }
};
</script>